import loadable from "@loadable/component";

import { demoPlantDependSheets } from "./dependSheets";
import { StrictViewType } from "./types";

const ViewRender = loadable(() => import("./render"));

export const viewTypeDemoPlantLines: StrictViewType = {
  key: "demoPlantLines",
  displayName: "生産デモ（ガントチャート）",
  dependSheets: demoPlantDependSheets,
  configSchemas: [],
  render: ViewRender as any,
};
